import { render, staticRenderFns } from "./RsaSchedaPazientePage.vue?vue&type=template&id=313ae78c"
import script from "./RsaSchedaPazientePage.vue?vue&type=script&lang=js"
export * from "./RsaSchedaPazientePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports